import type { OnboardingContent } from './types';

export const PLANNER_ONBOARDING: OnboardingContent = {
  role: 'PLANNER',
  roleLabel: 'Lập kế hoạch',
  tagline: 'Xem dự báo, theo dõi điều chỉnh, báo cáo cho ban điều hành.',
  steps: [
    {
      id: 'planner-1-welcome',
      title: 'Chào mừng tới Kế hoạch nhân sự v2',
      body:
        'Bạn có thể xem dự báo nhân lực 14 ngày tới cho từng kho và từng khách hàng, theo dõi tiến độ phê duyệt điều chỉnh từ KAM, và xuất báo cáo cho ban điều hành.',
    },
    {
      id: 'planner-2-overview',
      title: 'Mở Dự báo tổng quan',
      body:
        'Trang "Dự báo" cho bạn bức tranh 14 ngày: tổng đơn, tổng giờ làm, số ca, độ tin cậy. Cột màu đỏ/vàng là ngày cần lưu ý.',
      ctaLabel: 'Mở Dự báo',
      ctaHref: '/planner/forecast',
    },
    {
      id: 'planner-3-customer',
      title: 'Xem theo khách hàng',
      body:
        'Mục "Khách hàng" trong Dự báo cho bạn biết khách nào đóng góp bao nhiêu đơn. Đây là nơi bạn so sánh và theo dõi từng đối tác.',
      ctaLabel: 'Danh sách khách hàng',
      ctaHref: '/planner/forecast/customer',
    },
    {
      id: 'planner-4-review',
      title: 'Theo dõi điều chỉnh',
      body:
        'Khi KAM gửi điều chỉnh forecast, trạng thái NEW → SEEN → ACCEPTED/REJECTED hiển thị ở "Phê duyệt". Bạn có thể chấp nhận hoặc đề xuất từ chối kèm lý do.',
      ctaLabel: 'Phê duyệt',
      ctaHref: '/planner/forecast/review',
    },
    {
      id: 'planner-5-help',
      title: 'Trợ giúp luôn sẵn sàng',
      body:
        'Bấm "Trợ giúp" trong thanh bên để xem checklist theo tác vụ, hoặc chạy lại hướng dẫn này khi cần.',
      ctaLabel: 'Mở Trợ giúp',
      ctaHref: '/help',
    },
  ],
};
